export enum ConsultationToolbarSelectorTypeEnum {
    ALL_CONSULTATIONS = 'diagnosis.modals.allConsults',
    PENDING_CONSULTATIONS = 'diagnosis.modals.pendingConsults',
    SOLVED_CONSULTATIONS = 'diagnosis.modals.solvedConsults',
    CONSULTANTS = 'diagnosis.modals.consultants'
}
